<template>
  <div class="text-left" v-if="item">
    <p class="space-x-4">
      <span class="name">{{ item.receiver }}</span>
      <span class="phone">{{ item.phone }}</span>
    </p>
    <p class="text_display">{{ `${item.area.names} ${item.address}` }}</p>
  </div>
</template>
<script>
export default {
  props: { item: Object },
  setup() {
    return {};
  },
};
</script>

<style lang="scss">

.text_display {
  width: 100%;
  height: 3rem;
  overflow: hidden;
  -webkit-line-clamp: 2;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
}

</style>
